import type { NewsItem } from "@/types/content";

export const newsItems: NewsItem[] = [
  {
    id: "n1",
    title: "《暗夜追光》口碑持续走高，华语悬疑迎来开年第一匹黑马",
    date: "2026-01-24",
    summary:
      "上映一周票房突破 6 亿，豆瓣评分稳定在 8.4，观众热议其克制到近乎冷酷的叙事方式。",
    category: "票房动态",
    image:
      "https://readdy.ai/api/search-image?query=cinema%20red%20carpet%20at%20a%20film%20festival%20at%20night%2C%20glamorous%20editorial%20news%20photo%2C%20cinematic%20no%20text&width=600&height=400&seq=news-1&orientation=landscape",
    workId: "m1",
  },
  {
    id: "n2",
    title: "《星际信使》发布 IMAX 特辑，导演谈「孤独的浪漫」",
    date: "2026-02-16",
    summary:
      "导演 Oliver Grant 首次公开分享单程航行设定的灵感来源，并透露结尾三分钟为实景拍摄。",
    category: "幕后揭秘",
    image:
      "https://readdy.ai/api/search-image?query=film%20set%20behind%20the%20scenes%20with%20camera%20and%20lighting%20equipment%2C%20warm%20cinematic%20editorial%20photo%2C%20no%20text&width=600&height=400&seq=news-2&orientation=landscape",
    workId: "m6",
  },
  {
    id: "n3",
    title: "《迷雾之城》官宣第二季，原班人马回归",
    date: "2026-01-30",
    summary:
      "制作方确认第二季已进入前期筹备，故事将把镜头从旧工厂转向城市另一端的港口区。",
    category: "剧集预告",
    image:
      "https://readdy.ai/api/search-image?query=stacked%20film%20reels%20and%20a%20clapperboard%20on%20a%20wooden%20desk%2C%20cinematic%20editorial%20photo%2C%20no%20text&width=600&height=400&seq=news-3&orientation=landscape",
    workId: "s1",
  },
  {
    id: "n4",
    title: "《银河边缘》季终集创平台收视新高，主题曲同步上线",
    date: "2026-05-30",
    summary:
      "季终集上线 24 小时内播放量突破平台纪录，官方同步释出完整版原声带。",
    category: "行业观察",
    image:
      "https://readdy.ai/api/search-image?query=modern%20cinema%20theater%20interior%20with%20rows%20of%20empty%20red%20seats%2C%20editorial%20photography%2C%20cinematic%20no%20text&width=600&height=400&seq=news-4&orientation=landscape",
    workId: "s8",
  },
  {
    id: "n5",
    title: "《长街旧梦》修复版重映，再登文艺片话题榜",
    date: "2025-12-12",
    summary:
      "时隔一年，修复版以 4K 画质回归院线，导演苏文清出席映后谈分享创作初衷。",
    category: "影展资讯",
    image:
      "https://readdy.ai/api/search-image?query=nostalgic%20retro%20film%20projector%20in%20a%20dark%20small%20theater%2C%20warm%20cinematic%20editorial%20photo%2C%20no%20text&width=600&height=400&seq=news-5&orientation=landscape",
    workId: "m5",
  },
  {
    id: "n6",
    title: "《潮汐之城》入围亚洲电影大奖最佳摄影",
    date: "2025-09-01",
    summary:
      "影片凭借细腻的海岸镜头与自然光运用获得提名，成为本届热门讨论对象之一。",
    category: "奖项提名",
    image:
      "https://readdy.ai/api/search-image?query=golden%20trophy%20statue%20on%20a%20stage%20with%20soft%20spotlight%2C%20awards%20editorial%20photo%2C%20cinematic%20no%20text&width=600&height=400&seq=news-6&orientation=landscape",
    workId: "m3",
  },
];